module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-container', {
    staticClass: " main centered",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    attrs: {
      "id": "main"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-row', {
    staticClass: "main-text"
  }, [_c('b-container', {
    staticClass: "centered"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "centered",
    attrs: {
      "md": "12"
    }
  }, [_vm._v("\n\t\t\t\t\tКурсы экскурсоводов\n\t\t\t\t  ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_vm._v("\n\t\t\t\t\t   Первое занятие 2 октября 2025 в 19:00\n\t\t\t\t\t   "), _c('div', {
    staticStyle: {
      "font-size": "57%"
    }
  }, [_vm._v("по адресу: Лиговский пр. д.10 (холл гостиницы «Октябрьская»)")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "btn-row"
  }, [_c('b-col', {
    staticClass: "centered",
    attrs: {
      "md": "12"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Записаться "), _c('span', {
    staticClass: "d-none d-md-inline-block"
  }, [_vm._v("на первое занятие")])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "57%"
    }
  }, [_vm._v("Количество мест ограничено. Успейте записаться!")]), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "tel:+78129161500"
    }
  }, [_vm._v("+7 (812) 916-15-00")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "57%"
    }
  }, [_vm._v("Позвоните нам и мы развеем ваши сомнения!")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.wasScrolled),
      expression: "!wasScrolled"
    }],
    staticClass: "fa fa-arrow-circle-o-down fa-2x scroll-down-btn",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.scrollDown
    }
  })])], 1), _vm._v(" "), _c('b-container', {
    staticClass: "my-4"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "centered",
    attrs: {
      "md": "12"
    }
  }, [_vm._v("\nВСЕМ,"), _c('br'), _vm._v("\nКТО любит наш город \n       и готов рассказывать о нем бесконечно,  "), _c('br'), _vm._v("\nКТО хочет узнать больше о Санкт-Петербурге \n                              и пригородах,"), _c('br'), _vm._v("\nКТО стремится стать профессиональным экскурсоводом.\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "my-4"
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-modal', {
    attrs: {
      "id": "fastEnrollModal",
      "title": "Запись на курсы",
      "hideFooter": true
    },
    on: {
      "shown": function($event) {
        _vm.yaEvent('openTrialLessonForm')
      }
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('ext-form', {
    attrs: {
      "submitBtnText": "Записаться",
      "submitProxy": {
        url: '/fastEnrollment.php',
        method: 'post'
      },
      "formData": _vm.formData,
      "validator": this.$validator,
      "scrollToError": false,
      "submitBtnClasses": "btn btn-success float-right",
      "successMsg": "Заявка успешно отправлена",
      "errorMsg": "Ошибка, попробуйте позже"
    },
    on: {
      "submitSuccess": _vm.onSubmit,
      "submitFailed": function($event) {
        _vm.yaEvent('sendTrialLessonForm', 'ошибка при отправке')
      }
    }
  }, [_c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('fio')
    },
    attrs: {
      "label": "Фамилия Имя Отчество",
      "feedback": _vm.errors.first('fio')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.fio),
      expression: "formData.fio"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fio"
    },
    domProps: {
      "value": (_vm.formData.fio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.fio = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('tel')
    },
    attrs: {
      "label": "Телефон",
      "feedback": _vm.errors.first('tel')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.tel),
      expression: "formData.tel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('+7 (###) ###-##-##'),
      expression: "'+7 (###) ###-##-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tel"
    },
    domProps: {
      "value": (_vm.formData.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.tel = $event.target.value
      }
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "centered",
    attrs: {
      "id": "courses"
    }
  }, [_vm._v("Что будет на бесплатном занятии")]), _vm._v(" "), _c('b-row', {
    staticClass: "courses-icon",
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "col-md-12 small"
  }, [_vm._v("\n\t\t\t\tВас ЖДЁТ:\n\t\t\t\t"), _c('ul', [_c('li', [_vm._v("Знакомство с профессией и квалификационными требованиями к экскурсоводам")]), _vm._v(" "), _c('li', [_vm._v("Информация об особенностях обучения")])]), _vm._v("\n\t\t\t\tВы СМОЖЕТЕ:\n\t\t\t\t"), _c('ul', [_c('li', [_vm._v("Оценить уровень дохода в профессии")]), _vm._v(" "), _c('li', [_vm._v("«примерить» профессию экскурсовода на себя")]), _vm._v(" "), _c('li', [_vm._v("Поучаствовать в розыгрыше с профессиональным уклоном")])]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Записаться на первое занятие!")])], 1)])], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-10"
  }), _vm._v(" "), _c('h2', {
    staticClass: "centered",
    attrs: {
      "id": "courses"
    }
  }, [_vm._v("Курсы")]), _vm._v(" "), _c('b-row', {
    staticClass: "centered courses-icon",
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'CoursesEntry'
      }
    }
  }, [_c('img', {
    staticClass: "mx-auto",
    attrs: {
      "src": require("../assets/7-02.png"),
      "alt": "",
      "width": "200"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n           Начальный уровень\n        ")])], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-10"
  }), _vm._v(" "), _c('h2', {
    staticClass: "centered"
  }, [_vm._v("Наши преимущества")]), _c('br'), _vm._v(" "), _c('b-row', {
    staticClass: "centered icon",
    attrs: {
      "align-h": "around"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "4",
      "sm": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/9-01.png"),
      "alt": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n           Трудоустройство отличников\n        ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/2-01.png"),
      "alt": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n           Курсы сертифицированы для аккредитации при Правительстве Санкт-Петербурга\n        ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/4-01.png"),
      "alt": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n          Расписание занятий в вечернее время\n        ")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "centered icon",
    attrs: {
      "align-h": "around"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "4",
      "sm": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/5-01.png"),
      "alt": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n          В курсе 9 экскурсий\n        ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/6-01.png"),
      "alt": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n           Практические занятия на базе туроператора по приему туристов в Санкт-Петербурге\n        ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/7-01.png"),
      "alt": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n          Практика проведения экскурсий на живой группе\n        ")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "centered icon",
    attrs: {
      "align-h": "around"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "4",
      "sm": "10"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'CoursesAdvanced'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/8-01.png"),
      "alt": "",
      "width": "150"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          Повышение квалификации экскурсоводов\n        ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4",
      "sm": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/3-01.png"),
      "alt": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n          Помесячная оплата\n        ")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "btn-row"
  }, [_c('b-col', {
    staticClass: "centered",
    attrs: {
      "md": "12"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Записаться")])], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-10"
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h2', {
    staticClass: "centered"
  }, [_vm._v("Отзывы")]), _c('br')])], 1), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: "col-md-12 col-12"
  }, [_c('carousel', {
    ref: "slider",
    attrs: {
      "perPage": _vm.slidePerPage,
      "autoplay": _vm.sliderAutoplay,
      "navigationEnabled": true,
      "navigationNextLabel": "<i class=\"fa fa-chevron-right fa-2x\" aria-hidden=\"true\"></i>",
      "navigationPrevLabel": "<i class=\"fa fa-chevron-left fa-2x\" aria-hidden=\"true\"></i>",
      "minSwipeDistance": 80
    },
    on: {
      "pageChange": _vm.collapseAll
    }
  }, _vm._l((_vm.feedbacks), function(item, index) {
    return _c('slide', {
      key: index
    }, [_c('b-row', {
      staticClass: "feedback"
    }, [_c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('img', {
      staticClass: " img-thumbnail rounded-circle",
      attrs: {
        "src": item.img,
        "width": "220",
        "alt": ""
      }
    })]), _vm._v(" "), _c('b-col', {
      attrs: {
        "md": "9"
      }
    }, [_c('p', {
      staticClass: "text-justify font-italic"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _vm._v(" "), (item.collapsed) ? [_c('b-collapse', {
      attrs: {
        "id": 'collapsed' + index
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.collapsed)
      }
    })]), _vm._v(" "), _c('b-btn', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: ('collapsed' + index),
        expression: "'collapsed' + index"
      }],
      attrs: {
        "variant": "link"
      }
    }, [_vm._v("\n                      Читать полностью\n                    ")])] : _vm._e()], 2), _vm._v(" "), _c('p', {
      staticClass: "text-right"
    }, [_vm._v("\n                  " + _vm._s(item.author) + "\n                ")])])], 1)], 1)
  }))], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f119098"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 237
// module chunks = 1